// @ts-strict-ignore
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { SetCustomerFeeFormData } from 'types/customers'
import { useCreateCustomerFeeSchema } from '../schemas/setCustomerFeeSchema'

export const useCreateCustomerFeeForm = () => {
  const { t } = useTranslation()
  const formSchema = useCreateCustomerFeeSchema(t)

  const form = useForm<SetCustomerFeeFormData>({
    resolver: yupResolver(formSchema),
  })

  const { control, formState, clearErrors, resetField, setValue, register, trigger, setError } =
    form

  const formValues = useWatch({ control }) as SetCustomerFeeFormData

  return {
    formValues,
    formState,
    errors: formState.errors,
    clearErrors,
    resetField,
    setValue,
    register,
    setError,
    trigger,
    form,
  }
}
